import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService} from '../base-api.service';
import {RolesModelService} from '../../Models/Core/roles-model.service';

@Injectable({
  providedIn: 'root'
})
export class RolesApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public model: RolesModelService,
  ) {
    super(injector);
  }


  /**
   * Obtener los roles
   *
   */
  public getRoles(save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getRoles', {}, 'get').subscribe({
        next: (response) => {
          if (save) {
            this.model.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }

}
